import { cn } from "@gymflow/helpers";
import { cva } from "class-variance-authority";
import { ReactNode } from "react";

export type StatusColorType =
  | "lightblue"
  | "warning"
  | "gray"
  | "error"
  | "success"
  | "secondary";

type StatusProps = {
  text: string | ReactNode;
  statusColor: StatusColorType;
};

const outerClasses = cva(
  "flex h-fit w-fit items-center gap-2 rounded-full px-2 py-0.5",
  {
    variants: {
      color: {
        lightblue: "bg-lightblue-100 dark:bg-lightblue-900",
        warning: "bg-warning-100 dark:bg-warning-900",
        gray: "bg-gray-100 dark:bg-gray-700",
        error: "bg-error-50 dark:bg-error-900",
        success: "bg-success-50 dark:bg-success-900",
        secondary: "bg-secondary-25 dark:bg-secondary-800",
      },
    },
  },
);

const innerDotWrapper = cva(
  "flex h-3.5 w-3.5 items-center justify-center rounded-full",
  {
    variants: {
      color: {
        lightblue: "bg-lightblue-500 dark:bg-lightblue-500",
        warning: "bg-warning-700 dark:bg-warning-500",
        gray: "bg-gray-500 dark:bg-gray-400",
        error: "bg-error-600 dark:bg-error-500",
        success: "bg-success-600 dark:bg-success-500",
        secondary: "bg-secondary-700 dark:bg-secondary-500",
      },
    },
  },
);

const innerDot = cva("h-2 w-2 rounded-full", {
  variants: {
    color: {
      lightblue: "bg-lightblue-100 dark:bg-lightblue-900",
      warning: "bg-warning-100 dark:bg-warning-900",
      gray: "bg-gray-100 dark:bg-gray-700",
      error: "bg-error-50 dark:bg-error-900",
      success: "bg-success-50 dark:bg-success-900",
      secondary: "bg-secondary-25 dark:bg-secondary-800",
    },
  },
});

export const Status = ({ text, statusColor }: StatusProps) => {
  return (
    <div className={cn(outerClasses({ color: statusColor }))}>
      <div className={cn(innerDotWrapper({ color: statusColor }))}>
        <div className={cn(innerDot({ color: statusColor }))} />
      </div>
      <div className="dark:text-gray-0 text-sm font-semibold text-gray-950">
        {text}
      </div>
    </div>
  );
};
